export const EXTENSIBLE_WORKFLOW_CONTEXT = 'sessionWorkflowContext';
export var NetworkMode;
(function (NetworkMode) {
    NetworkMode[NetworkMode["JSWebSockets"] = 0] = "JSWebSockets";
    NetworkMode[NetworkMode["LocalWorkflowsOnly"] = 1] = "LocalWorkflowsOnly";
    NetworkMode[NetworkMode["HostWebSockets"] = 2] = "HostWebSockets";
    NetworkMode[NetworkMode["HttpFallback"] = 3] = "HttpFallback"; //NYI ADO 7078542
})(NetworkMode || (NetworkMode = {}));
//# sourceMappingURL=messages-shared.js.map